import { Postrequestcall } from "../../request/Postrequest";
import { SAVE_USER_USAGES } from "../../constant/Apipath";

const UserUsages = async (props, loginData) => {
  try {
    const obj = {
      ReturnRecordId: false,
      ReturnRecordError: true,
      UserId: loginData?.userInformation?.UserId,
      SaveList: [
        {
          Id: 0,
          ModuleName: props,
          UserId: loginData?.userInformation?.UserId
        }
      ]
    };

    await Postrequestcall(SAVE_USER_USAGES, obj, loginData?.accessToken);
  } catch (err) {
    console.log("UserUsages-> Error Saving User Usages: ", err);
  }
};

export default UserUsages;
